import { render, staticRenderFns } from "./QueueItemDetailDialog.vue?vue&type=template&id=543782de"
import script from "./QueueItemDetailDialog.vue?vue&type=script&lang=js"
export * from "./QueueItemDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports